import React, { memo, SyntheticEvent, useCallback } from 'react'
import { Tooltip } from '@cargomart/ui'
import IconClear from 'assets/clear.svg?react'
import IconDropdown from 'assets/dropdown.svg?react'
import IconError from 'assets/error.svg?react'
import cn from 'classnames'
import { IconSpinner } from 'components/IconSpinner'
import { hasTextInError } from 'helpers/hasTextInError'
import noop from 'lodash/noop'

import s from './BaseSelect.module.less'

interface TSelectIconsProps {
  error?: string | boolean
  hasClearIcon?: boolean
  hasDropDownIcon?: boolean
  hasIcon?: boolean
  isDisabled?: boolean
  isLoading?: boolean
  isOpen?: boolean
  onClear?: (event: SyntheticEvent<SVGSVGElement>) => void
}

export const SelectIcons = memo(function SelectIcons({
  error = false,
  isOpen = false,
  isLoading = false,
  isDisabled = false,
  hasClearIcon = false,
  hasIcon = true,
  onClear = noop
}: TSelectIconsProps) {
  const handleClear = useCallback(
    (event: SyntheticEvent<SVGSVGElement>) => {
      event.stopPropagation()

      if (!isDisabled) {
        onClear(event)
      }
    },
    [isDisabled, onClear]
  )

  if (isLoading) {
    return <IconSpinner />
  }

  return (
    <>
      {hasTextInError(error) && (
        <Tooltip content={error}>
          <span>
            <IconError className={s.icon_error} />
          </span>
        </Tooltip>
      )}
      {hasClearIcon && (
        <IconClear className={cn(s.icon, { [s.icon_disabled]: isDisabled })} onClick={handleClear as any} />
      )}
      {hasIcon && (
        <IconDropdown
          className={cn(s.icon, s['icon-arrow'], { [s['icon-arrow_up']]: isOpen }, { [s.icon_disabled]: isDisabled })}
        />
      )}
    </>
  )
})
